import i18n from 'services/base/i18n';

export default {
  // The title for the page that lists parental controls
  parentalControls: () => i18n.pgettext('Pages|List Parental Controls', 'PARENTAL CONTROLS'),
  // The header for the list of active rules
  activeRules: () => i18n.pgettext('Pages|List Parental Controls', 'ACTIVE RULES'),
};
